export default __webpack_public_path__ + "static/media/Encounter.cf87b7d1.svg";